import { zhCN } from "../../../../date-fns/locale/zh-CN.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    zhCN
  }
};